import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import Radio from "../forms/radio";

var FilterPopoverRadio = function FilterPopoverRadio(_ref) {
  var filterKey = _ref.filterKey,
      options = _ref.options,
      _onChange = _ref.onChange,
      value = _ref.value;
  return _.map(options, function (option) {
    return /*#__PURE__*/React.createElement(Radio, {
      key: option.key,
      className: "et--filter-option",
      name: option.name,
      value: option.key,
      checked: value === option.key,
      onChange: function onChange() {
        return _onChange(filterKey, option.key);
      }
    }, option.name);
  });
};

FilterPopoverRadio.propTypes = {
  filterKey: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.string
};
export default FilterPopoverRadio;